import paper from 'paper';
import { Tool } from 'paper';
import store from '../store';
import PainterService from '@/services/PainterService';

/* eslint-disable no-undef */
function hitOptions() {
    return {
        segments: true,
        stroke: true,
        curves: true,
        fill: true,
        guide: false,
        tolerance: 8 / store.getters.zoom
    };
}

function onMouseMove(event) {
    paper.project.getItems({ selected: true }).forEach(item => item.selected = false);

    let item = getHitItem(event);
    PainterService.displayItemSize();
    if (item) PainterService.displayBounds(item.bounds);
}

async function onMouseUp(event) {
    if(event.event.button > 0) {
        event.preventDefault();
        event.stopPropagation();
        return false;
    }

    if (isClick(event)) {
        let item = getHitItem(event);
        if (item) {
            await store.dispatch('setSizeItemId', item.id);
            PainterService.displayItemSize();
        }
    }
}

function isClick(event) {
    return event.downPoint == null || event.downPoint.isClose(event.point, hitOptions().tolerance);
}

function getHitItem(event) {
    let hitItems = getHitItems(event)
    return hitItems.length > 0 ? hitItems[0] : null;
}

function getHitItems(event) {
    let hitResults = paper.project.layers.blueprint.hitTestAll(event.point, hitOptions());

    if (hitResults == null) {
        return;
    }

    return hitResults
        .filter(r => r.item)
        .map(r => r.item);
}

export const ItemSizeTool = new Tool({
    name: 'itemsize',
    onMouseMove,
    onMouseUp
});
